//one-card-subject/card.tsx
import * as React from 'react';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Avatar from 'antd/lib/avatar';
import Select from 'antd/lib/select';
import Badge from 'antd/lib/badge';
import Icon from 'antd/lib/icon';
import Skeleton from 'antd/lib/skeleton';
import Tag from 'antd/lib/tag';
import Tooltip from 'antd/lib/tooltip';
import { useCtx } from 'one-ui-provider';
import {
  useDispatch,useSelector
} from 'react-redux';

const {
  Option,
} = Select;

import {
  buildGearActionsMenu,
} from 'one-ui-gear/src/actions';


import {
  Card
} from 'one-ui-card/src/card';

import {
  Value,
  Values,
} from 'one-ui-values';

import {
  FinessePhonePlugin
} from 'one-comp-phone';

import {
  //CardNoData,
  CardVerifySubject,
  CardSubjectScreenpop
} from 'one-ui-card';

import {
  SubjectCardProps
} from './props';

import {
  OneSubjectModal
} from './model';

import {
  setAction as globalSearchAction,
} from 'one-state-patient-global-search';

/**
 *  card renders all patient related data
 * @param props component properties
 *
 */
export const SubjectCard = <M extends OneSubjectModal>(
  props: SubjectCardProps<M>
) => {
  const {
    model,
    title,
    gearActions,
    verified,
    onClick,
    skeleton,
    activeprob,
    allergy,
    pediatricage,
  } = props;

  let {
    subjects,
    selected,
  } = model;

  const {
    subject_skeleton,
  } = skeleton;

  //To access setting.js file  
  const { makecall, settings } = useCtx();
  const subjectdemo = useSelector((state:any)=>(state.selectedsubjectinfo));
  const { uisettings, epicendpoints: { searchID } } = settings;
  const dispatch = useDispatch();
  //To get the patientverified value
  const { dashboardtab: { patientverified },preferred_name } = uisettings;
  const patientMatch = useSelector((state: any) => (state.patientMatch));
  const { subject_card } = uisettings;
  const {
    name_display,
    preferred_name_display,
    dob_display,
    mrn_display,
    contactnumber_display,
    address_display,
    age_gender_at_title_display,
    email_display,
    ssn_display
  } = subject_card;
  const patientcount = subjects ? subjects.length : "";
  let patientverification = <div></div>;
  // check for age config from settings otherwise consider 18
  let checkpediatric = pediatricage ? pediatricage : 18;
  //If the selected data gets reset we are fetching from subjectdemo reducer
  if(selected === undefined && subjectdemo) {
      selected = subjectdemo
  }

  let validsearchid = ""
  if (searchID == "MRN"){
      validsearchid = "MRN"
  }
  else if (searchID == "EPI") {
      validsearchid = "EPI"
  }
  else if (searchID == "CLINIC-PAT") {
    validsearchid = "MRN"
}

  if (patientcount > 0) {
    //to check whether patientverified is enabled or not  
    if (patientverified) {
      if (verified) {
        patientverification = (
          <div>
            <Icon
              type="check-circle"
              theme="twoTone"
              twoToneColor="#52c41a"
            />
            <span className="patientverified_class">Verified</span>
          </div>
        )
      }
      //ADPAC-956
      // else {
      //   patientverification = (
      //     <>
      //       <Icon
      //         type="close-circle"
      //         theme="twoTone"
      //         twoToneColor="red"
      //       />
      //       <span className="unverified_class">Unverified</span>
      //     </>
      //   )
      // }
    }
  }
  const patientui = (
    <Row type="flex">
      <div style={{width: '80px'}}>
          <a onClick={onClick} style={{ marginLeft: '15px' }} className="avatar-badge">
            <Badge count={patientcount} showZero >
              <Avatar size="large">{selected?.initials}</Avatar>
            </Badge>
          </a>
          <br />
          <br />
          {patientverification}
          {
            patientMatch?.matchType && (
              <>
                <div className='patientverified_class' style={{marginLeft: '13px', lineHeight: '1.1rem'}}>Match Criteria:</div>
                <div style={{marginLeft: '18px', lineHeight: '1.1rem', fontSize: '1.1rem'}}>{patientMatch.matchType}</div>
              </>
            )
          }
        </div>
      <Row type="flex" gutter={[16, 32]} style={{ flex: 1 }}>
        <Col span={24}>
          {(name_display) && ((selected?.firstname) || (selected?.lastname)) && (<div className="description-info__name">
            <span>{selected?.lastname}   {selected?.firstname} {(preferred_name)&&(selected?.preferredName)&&'"'+selected?.preferredName+'"'}</span>
            <a onClick={onClick}>Change</a>
          </div>)
          }
          <Row type="flex" gutter={[40, 28]}>
            <Col span={14}>
              <Values>
                {/* <Value
                  label='Contact number'
                  value={selected?.contact}
                /> */}
                {preferred_name_display && (
                  <Value label="Preferred Name" value={selected?.preferredName ? selected.preferredName : ''} />
                )}
                {
                  (contactnumber_display) && (<FinessePhonePlugin
                    label='Contact Number'
                    phone={selected?.contact_formatted}
                    type={'subject'}
                    makecall={makecall} />)
                }
                {
                  (email_display) && (<Value label="Email" value={selected?.email} />)
                }
                {
                  (address_display) && (<Value
                    label="Address"
                    value={selected?.address}
                  />)
                }
              </Values>
            </Col>
            <Col span={10}>
              <Values>
                {
                  (dob_display) && (<Value label="DOB" value={selected?.dob} />)
                }
                {
                  (mrn_display) && (<Value label= { validsearchid } value={selected?.mrn} />)
                }
                {
                  (ssn_display) && (<Value label="Last 4 SSN" value={selected?.ssn} />)
                }
              </Values>
            </Col>
          </Row>
          <Row type="flex" gutter={[40, 28]}>
            <Col span={20} style={{ paddingTop: "0px !important", paddingBottom: "0px !important" }} >
              {
                ((selected?.age) && (Number(selected.age) < checkpediatric)) && (
                  <Tooltip title={"Patient Type"}>
                    <Tag color="green" className="ant-tag--rounded">Pediatric</Tag>
                  </Tooltip>
                )
              }
            &nbsp;
            {
                ((selected?.initials) && (activeprob)) && (
                  <Tooltip title={"Active Problem"}>
                    <Tag color="red" className="ant-tag--rounded">{activeprob}</Tag>
                  </Tooltip>
                )
              }
            &nbsp;
            {
                ((selected?.initials) && (allergy)) && (
                  <Tooltip title={"Active Allergy"}>
                    <Tag color="orange" className="ant-tag--rounded">{allergy}</Tag>
                  </Tooltip>
                )
              }
            </Col>
            <Col span={4}>
            </Col>
          </Row>
        </Col>
      </Row>
    </Row>
  )

  // default set to patient screen
  let result = patientui;
  // If subject skeleton is true
  if (subject_skeleton) {
    result = (<Skeleton avatar active paragraph={{ rows: 3 }} />);
  }
  // check for the no details found on api response
  if (subjects?.length === 0 && selected === undefined) {
    result = (
      <>
      <a onClick={() => {
                   dispatch(globalSearchAction(true));
                }}>
                <CardSubjectScreenpop/>
            </a>
      </>
    )
    
    
  }
  if (subjects && (Object.keys(subjects).length > 0) && (selected === undefined || Object.keys(selected).length === 0)) {
    result = (
        <CardVerifySubject onClick={onClick} />
    )
  }

  let subjectTitle = title;
  if (verified && selected) {
    subjectTitle = title + " is a Patient ";

  }
  if (age_gender_at_title_display) {
    subjectTitle = subjectTitle?.concat(selected?.age ? " (" + selected?.age + " year old " + selected?.gender + ")" : "");
  }
  return (
    <Card
      title={subjectTitle}
      gearActions={
        buildGearActionsMenu(gearActions)
      }
      body={(
        result
      )}
    />
  );
};
